import { FC, useEffect, useState } from "react";
import "./ModalSortSectionsInsert.scss";
import ModalDefault from "../../components/ModalDefault/ModalDefault";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../providers/AuthProvider";
import { useForm } from "react-hook-form";
import { Card, Col, FormGroup, ListGroup, Row } from "react-bootstrap";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { schema } from "./Validate";
import { useSections } from "../../providers/Articles/Sections/SectionsProvider";
import ReactSelect from "react-select";
import { customStyles } from "../../models/SelectCustomStyles";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { useAgentsCategories } from "../../providers/Agents/AgentsCategories/AgentsCategoriesProvider";

interface ModalSortSectionsInsertProps {
  show: boolean;
  onClose: () => void;
}

const ModalSortSectionsInsert: FC<ModalSortSectionsInsertProps> = ({
  show,
  onClose,
}) => {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);
  const [sortSectionsInfo, setSortSectionsInfo] = useState<any | null>(null);
  const [selectedCategories, setSelectedCategories] = useState<any | null>(
    null
  );

  const { onInvalid } = useAuth();

  const {
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const { categoriesOptions, setParams: setParamsAgentsCategories } =
    useAgentsCategories();

  const { sectionsOptions, handleListSectionsOption, handleSortSections } =
    useSections();

  const handleClose = () => {
    reset();
    setValue("category_id", null);
    setValue("section_id", null);
    setSortSectionsInfo(null);
    setSelectedCategories(null);
    onClose();
  };

  useEffect(() => {
    if (show) {
      setParamsAgentsCategories({
        withPaginate: false,
        filter: { only_active: true },
      });
    }
  }, [show]);

  useEffect(() => {
    setValue("category_id", selectedCategories?.value || null);
    if (selectedCategories) {
      handleListSectionsOption({
        withPaginate: false,
        filter: { only_active: true, category_id: selectedCategories?.value },
      });
    }
  }, [selectedCategories]);

  useEffect(() => {
    if (selectedCategories && sectionsOptions) {
      setSortSectionsInfo(sectionsOptions);
    }
  }, [sectionsOptions]);

  const handleOnDragEnd = async (result: any) => {
    if (!result.destination) return;

    const items = Array.from(sortSectionsInfo);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setSortSectionsInfo(items);
    await handleSortSections({
      sections: items.map((item: any, index: number) => ({
        id: item.value,
        order: index,
      })),
    });
  };

  return (
    <ModalDefault
      title="Ordernar Seções"
      show={show}
      onClose={handleClose}
      sizeModal={"xl"}
      showFooter={true}
      showButtonSpinner={isLoadingSubmit}
      disabledSubmit={isLoadingSubmit}
      backdrop="static"
      backgroundColor="#f8f9fa"
    >
      <div
        className="ModalSortSectionsInsert"
        data-testid="ModalSortSectionsInsert"
      >
        <Row>
          <Col md={5}>
            <FormGroup className="form-group">
              <label htmlFor="category_id">CATEGORIA</label>
              <ReactSelect
                isSearchable
                isClearable
                options={categoriesOptions ?? []}
                value={selectedCategories}
                placeholder="Selecione"
                className={`form-control p-0 ${onInvalid(errors?.category_id)}`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(e) => {
                  setSelectedCategories(e ?? null);
                }}
              />
              <ErrorMessage
                name={"Categoria"}
                type={errors?.category_id?.type?.toString()}
              />
            </FormGroup>
          </Col>
          <Col md={7}>
            <Card>
              <div className="p-4">
                <h5 className="mb-4">Seções</h5>

                <ListGroup className="navbar-nav sections">
                  <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="pages">
                      {(provided: any) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {sortSectionsInfo && sortSectionsInfo?.length > 0 ? (
                            <>
                              {sortSectionsInfo?.map(
                                (item: any, key: number) => (
                                  <Draggable
                                    key={item?.value || key}
                                    draggableId={
                                      item?.value?.toString() ||
                                      key?.toString() ||
                                      ""
                                    }
                                    index={key}
                                  >
                                    {(provided: any, snapshot: any) => (
                                      <div className="ps-3 pe-1" key={key}>
                                        <div
                                          className={`nav-link text-wrap d-flex align-items-center py-2 ${
                                            snapshot.isDragging
                                              ? "background"
                                              : ""
                                          }`}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                        >
                                          <div
                                            className="text-center"
                                            {...provided.dragHandleProps}
                                          >
                                            <i className="fas fa-grip-vertical"></i>
                                          </div>
                                          <span className="nav-link-text ms-2">
                                            {item?.label || ""}
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                )
                              )}
                            </>
                          ) : (
                            <div className="d-flex justify-content-center">
                              Não há registro
                            </div>
                          )}

                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </ListGroup>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </ModalDefault>
  );
};

export default ModalSortSectionsInsert;
